import {Heart, Instagram} from 'lucide-react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import logoS from '@/assets/swimmie-logo-s.png';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-white relative overflow-hidden">
            {/* Wave divider at top */}
            <div className="wave-divider-top">
                <svg
                    viewBox="0 0 1440 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                >
                    <path
                        d="M0,32L60,37.3C120,43,240,53,360,53.3C480,53,600,43,720,37.3C840,32,960,32,1080,37.3C1200,43,1320,53,1380,58.7L1440,64L1440,80L1380,80C1320,80,1200,80,1080,80C960,80,840,80,720,80C600,80,480,80,360,80C240,80,120,80,60,80L0,80Z"
                        fill="rgb(71, 107, 252)"
                    />
                </svg>
            </div>

            <div className="pt-20 pb-8 px-4">
                <div className="max-w-6xl mx-auto">
                    {/* Main footer content */}
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">

                        {/* vlnka */}
                        <motion.div
                            className="md:col-span-5"
                            initial={{opacity: 0, y: 20}}
                            whileInView={{opacity: 1, y: 0}}
                            viewport={{once: true}}
                            transition={{duration: 0.5}}
                        >

                            {/* logo */}
                            <a href="/"><img src={logoS} alt="Swimmie" className="h-9 mb-5 ml-0"/></a>


                            <p className="text-foreground/70 leading-relaxed max-w-sm">
                                První česká tréninková aplikace pro plavce.
                            </p>
                        </motion.div>

                        {/* Links */}
                        <motion.div
                            className="md:col-span-3"
                            initial={{opacity: 0, y: 20}}
                            whileInView={{opacity: 1, y: 0}}
                            viewport={{once: true}}
                            transition={{duration: 0.5, delay: 0.1}}
                        >
                            <h4 className="font-semibold mb-5 text-foreground text-sm uppercase tracking-wider">
                                Odkazy
                            </h4>
                            <ul className="space-y-3">
                                <li>
                                    <Link to="/vop" className="text-sm">Podmínky použití</Link>
                                </li>
                                <li>
                                    <Link to="/vop" className="text-sm">
                                        Zásady ochrany osobních údajů
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/voucher" className="text-sm">Dárkový voucher</Link>
                                </li>
                            </ul>
                        </motion.div>

                        {/* Social */}
                        <motion.div
                            className="md:col-span-4"
                            initial={{opacity: 0, y: 20}}
                            whileInView={{opacity: 1, y: 0}}
                            viewport={{once: true}}
                            transition={{duration: 0.5, delay: 0.2}}
                        >
                            <h4 className="font-semibold mb-5 text-foreground text-sm uppercase tracking-wider">
                                Sledujte nás
                            </h4>
                            <div className="flex flex-col gap-3">
                                <a
                                    href="https://instagram.com/swimmie.cz"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="group flex items-center gap-3"
                                >
                                    <div
                                        className="w-10 h-10 rounded-xl bg-muted flex items-center justify-center group-hover:bg-primary/10 transition-colors">
                                        <Instagram className="h-5 w-5"/>
                                    </div>
                                    <span className="text-sm font-medium">@swimmie.cz</span>
                                </a>

                                <a
                                    href="https://instagram.com/app.swimmie"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="group flex items-center gap-3"
                                >
                                    <div
                                        className="w-10 h-10 rounded-xl bg-muted flex items-center justify-center group-hover:bg-primary/10 transition-colors">
                                        <Instagram className="h-5 w-5"/>
                                    </div>
                                    <span className="text-sm font-medium">@app.swimmie</span>
                                </a>
                            </div>
                        </motion.div>
                    </div>

                    {/* Divider */}
                    <div className="border-t border-gray-200 pt-8">
                        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                            <p className="text-sm text-foreground/50">
                                &copy; {currentYear} Swimmie by LKL, s.r.o.
                            </p>
                            <p className="text-sm text-foreground/50 flex items-center gap-1">
                                Vytvořeno s <Heart className="h-4 w-4 text-primary fill-primary"/> pro plavce
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
